import { createReducer, on } from "@ngrx/store";
import { tenantInformationInitialState } from "../../initial-states/tenant-information.state";
import { loadTenantAppCatalogApps, loadTenantAppCatalogAppsFailed, loadTenantAppCatalogAppsSuccess, loadTenantInternalSettings, loadTenantInternalSettingsFailed, loadTenantInternalSettingsSuccess, loadTenantSharingSettings, loadTenantSharingSettingsFailed, loadTenantSharingSettingsSuccess, loadTenantBrandCenter, loadTenantBrandCenterSuccess, loadTenantBrandCenterFailed, loadTenantSensitivityLabels, loadTenantSensitivityLabelsSuccess, loadTenantSensitivityLabelsFailed, loadTenantRetentionLabels, loadTenantRetentionLabelsSuccess, loadTenantRetentionLabelsFailed, loadTenantGroupSettings, loadTenantGroupSettingsSuccess, loadTenantGroupSettingsFailed } from "../../actions/tenant-information.actions";

export const TenantInformationReducer = createReducer(
	tenantInformationInitialState,

	// Triggered when requesting tenant sharing settings from backend storage
	on(loadTenantSharingSettings, (state) => ({
		...state,
		sharingSettings: {
			...state.sharingSettings,
			loading: true
		}
	})),

	// Successfully loaded tenant sharing settings from backend storage
	on(loadTenantSharingSettingsSuccess, (state, { sharingSettings }) => ({
		...state,
		sharingSettings: {
			...state.sharingSettings,
			loading: false,
			loadedOnce: true,
			value: sharingSettings
		}
	})),

	// Failed to load tenant sharing settings from backend storage
	on(loadTenantSharingSettingsFailed, (state, { error }) => ({
		...state,
		sharingSettings: {
			...state.sharingSettings,
			loading: false,
			loadedOnce: false,
			error: error
		}
	})),

	// Triggered when requesting tenant app catalog apps from backend storage
	on(loadTenantAppCatalogApps, (state) => ({
		...state,
		apps: {
			...state.apps,
			loading: true
		}
	})),

	// Successfully loaded tenant app catalog apps from backend storage
	on(loadTenantAppCatalogAppsSuccess, (state, { appCatalogApps, tenantAppCatalogUri }) => ({
		...state,
		apps: {
			...state.apps,
			loading: false,
			loadedOnce: true,
			value: { apps: appCatalogApps, tenantAppCatalogUri: tenantAppCatalogUri }
		}
	})),

	// Failed to load tenant app catalog apps from backend storage
	on(loadTenantAppCatalogAppsFailed, (state, { error }) => ({
		...state,
		apps: {
			...state.apps,
			loading: false,
			loadedOnce: false,
			error: error
		}
	})),

	// Triggered when requesting tenant internal settings from backend storage
	on(loadTenantInternalSettings, (state) => ({
		...state,
		internalSettings: {
			...state.internalSettings,
			loading: true
		}
	})),

	// Successfully loaded tenant internal settings from backend storage
	on(loadTenantInternalSettingsSuccess, (state, { internalSettings }) => ({
		...state,
		internalSettings: {
			...state.internalSettings,
			loading: false,
			loadedOnce: true,
			value: internalSettings
		}
	})),

	// Failed to load tenant internal settings from backend storage
	on(loadTenantInternalSettingsFailed, (state, { error }) => ({
		...state,
		internalSettings: {
			...state.internalSettings,
			loading: false,
			loadedOnce: false,
			error: error
		}
	})),

	// Triggered when requesting tenant brand center status
	on(loadTenantBrandCenter, (state) => ({
		...state,
		brandCenter: {
			...state.brandCenter,
			loading: true
		}
	})),

	// Successfully loaded tenant brand center
	on(loadTenantBrandCenterSuccess, (state, { brandCenter }) => ({
		...state,
		brandCenter: {
			...state.brandCenter,
			loading: false,
			loadedOnce: true,
			value: brandCenter
		}
	})),

	// Failed to load tenant brand center
	on(loadTenantBrandCenterFailed, (state, { error }) => ({
		...state,
		brandCenter: {
			...state.brandCenter,
			loading: false,
			loadedOnce: true,
			error: error
		}
	})),

	// Triggered when requesting tenant sensitivity labels
	on(loadTenantSensitivityLabels, (state) => ({
		...state,
		sensitivityLabels: {
			...state.sensitivityLabels,
			loading: true,
			error: undefined
		}
	})),

	// Successfully loaded tenant sensitivity labels
	on(loadTenantSensitivityLabelsSuccess, (state, { sensitivityLabels }) => ({
		...state,
		sensitivityLabels: {
			...state.sensitivityLabels,
			loading: false,
			loadedOnce: true,
			value: sensitivityLabels,
			error: undefined
		}
	})),

	// Failed to load tenant sensitivity labels
	on(loadTenantSensitivityLabelsFailed, (state, { error }) => ({
		...state,
		sensitivityLabels: {
			...state.sensitivityLabels,
			loading: false,
			loadedOnce: false,
			error
		}
	})),

	on(loadTenantGroupSettings, (state) => ({
		...state,
		groupSettings: { ...state.groupSettings, loading: true, error: undefined }
	})),
	on(loadTenantGroupSettingsSuccess, (state, { groupSettings }) => ({
		...state,
		groupSettings: { ...state.groupSettings, loading: false, loadedOnce: true, value: groupSettings, error: undefined }
	})),
	on(loadTenantGroupSettingsFailed, (state, { error }) => ({
		...state,
		groupSettings: { ...state.groupSettings, loading: false, loadedOnce: false, error }
	})),

	on(loadTenantRetentionLabels, (state) => ({
		...state,
		retentionLabels: {
			...state.retentionLabels,
			loading: true,
			error: undefined
		}
	})),

	on(loadTenantRetentionLabelsSuccess, (state, { retentionLabels }) => ({
		...state,
		retentionLabels: {
			...state.retentionLabels,
			loading: false,
			loadedOnce: true,
			value: retentionLabels,
			error: undefined
		}
	})),

	on(loadTenantRetentionLabelsFailed, (state, { error }) => ({
		...state,
		retentionLabels: {
			...state.retentionLabels,
			loading: false,
			loadedOnce: false,
			error
		}
	})),
);
